import React from 'react';
import SVGIcon from '../components/SVGIcon';
import groupIcon from '../icons/prefilled/16x16/group.svg';
import * as styles from './GroupIcon.module.scss';

type SVGIconProps = Omit<React.ComponentProps<typeof SVGIcon>, 'children'>;

type GroupIconProps = SVGIconProps;

const GroupIcon = (props: GroupIconProps) => {
  return (
    <div className={styles.container}>
      <SVGIcon {...props}>{groupIcon}</SVGIcon>
    </div>
  );
};

export default GroupIcon;
